module.exports = __webpack_public_path__ + "static/media/participles2_img.47c459c6.JPG";